/**
 * Manual store-name → domain overrides. Used by lib/logo.ts to fetch
 * the correct logo when domain auto-detection picks the wrong one
 * (e.g. KLARNA entry getting hotels.com because parser merged blocks).
 *
 * Keys are lowercased store names (with non-alnum stripped) for fuzzy match.
 */
export const LOGO_DOMAIN_OVERRIDES: Record<string, string> = {
  klarna: "klarna.com",
  paypal: "paypal.com",
  stubhub: "stubhub.com",
  hotelscom: "hotels.com",
  jawagg: "jawa.gg",
  breitling: "breitling.com",
  apple: "apple.com",
  applecom: "apple.com",
  samsclub: "samsclub.com",
  officedepot: "officedepot.com",
  surlatable: "surlatable.com",
  surlatablecom: "surlatable.com",
  lenovo: "lenovo.com",
  lenovocom: "lenovo.com",
  getsupernatural: "getsupernatural.com",
  westerndigital: "westerndigital.com",
  arlo: "arlo.com",
  arlocom: "arlo.com",
  wellbots: "wellbots.com",
  blackanddecker: "blackanddecker.com",
  justmac: "justmac.com",
  corsair: "corsair.com",
  ninjakitchen: "ninjakitchen.com",
  verizon: "verizon.com",
  zoro: "zoro.com",
  woot: "woot.com",
  wootcom: "woot.com",
  tiktopshop: "tiktokshop.com",
  tiktop: "tiktokshop.com",
  googlestore: "store.google.com",
  google: "store.google.com",
  amazon: "amazon.com",
  walmart: "walmart.com",
  target: "target.com",
  bestbuy: "bestbuy.com",
  costco: "costco.com",
  newegg: "newegg.com",
  ebay: "ebay.com",
  nike: "nike.com",
  adidas: "adidas.com",
  lululemon: "lululemon.com",
  zara: "zara.com",
  uniqlo: "uniqlo.com",
  hm: "hm.com",
  asos: "asos.com",
  shein: "shein.com",
  ikea: "ikea.com",
  homedepot: "homedepot.com",
  lowes: "lowes.com",
  wayfair: "wayfair.com",
  sephora: "sephora.com",
  ulta: "ulta.com",
  dyson: "dyson.com",
  bose: "bose.com",
  sony: "sony.com",
  samsung: "samsung.com",
  microsoft: "microsoft.com",
  microsoftstore: "microsoft.com",
  hp: "hp.com",
  dell: "dell.com",
  asus: "asus.com",
  razer: "razerzone.com",
  logitech: "logitech.com",
  lego: "lego.com",
  fanatics: "fanatics.com",
  goat: "goat.com",
  stockx: "stockx.com",
  farfetch: "farfetch.com",
  mrporter: "mrporter.com",
  netaporter: "net-a-porter.com",
  ssense: "ssense.com",
  endclothing: "endclothing.com",
  matchesfashion: "matchesfashion.com",
  saksfifthavenue: "saksfifthavenue.com",
  saks: "saksfifthavenue.com",
  nordstrom: "nordstrom.com",
  bloomingdales: "bloomingdales.com",
  macys: "macys.com",
  jcpenney: "jcpenney.com",
  kohls: "kohls.com",
  shopify: "shopify.com",
  staples: "staples.com",
  petco: "petco.com",
  aritzia: "aritzia.com",
  petsmart: "petsmart.com",
  chewy: "chewy.com",
  gnc: "gnc.com",
  vitaminshoppe: "vitaminshoppe.com",
  iherb: "iherb.com",
  bhphotovideo: "bhphotovideo.com",
  bh: "bhphotovideo.com",
  adorama: "adorama.com",
};

/**
 * Returns the override domain for a given store name, or null if no override.
 */
export function getLogoOverride(name: string): string | null {
  const key = name.toLowerCase().replace(/[^a-z0-9]/g, "");
  return LOGO_DOMAIN_OVERRIDES[key] ?? null;
}
